export const environment = {
  production: false,
  // http://localhost:5043 es el puerto real de `dotnet run` (ver
  // Properties/launchSettings.json del backend) -- el /api es obligatorio,
  // los endpoints estan mapeados como /api/health y /api/turnstile/verify
  // (TurnstileVerificationService solo agrega "/turnstile/verify").
  apiBaseUrl: 'https://api.viajes.demo.reinvent-x.com/api',
  // Ningun consumidor usa esto todavia en el frontend -- se deja preparado
  // para cuando exista (ver plan-iac-reinvent-viajes-app.md, seccion
  // "Pendiente"). En un build real de CI (dev/prod) scripts/set-env.js lo
  // sobreescribe con el valor real (WEBSOCKET_URL, ver
  // 14-it-reinvent-viajes-frontend-pipeline/main.tf); en local (ng serve)
  // se queda con este valor.
  websocketUrl: 'wss://ws.viajes.demo.reinvent-x.com',
  contactFallback: {
    whatsappNumber: '529993232098',
    whatsappMessage: 'Hola, Viajes Demo. Me gustaría recibir información para planear mi próximo viaje.',
  },
  // Site key de prueba PUBLICADO por Cloudflare -- SIEMPRE pasa la
  // verificacion, para no bloquear el desarrollo local. No es secreto (a
  // diferencia del secret key, que nunca vive en el frontend, ver
  // plan-frontend-reinvent-viajes-app.md). Ver
  // https://developers.cloudflare.com/turnstile/troubleshooting/testing/
  turnstileSiteKey: '0x4AAAAAAEuFuDpfWQ9RJYwh',
};
